import React from 'react';
import { DashboardContent } from '@/layouts/dashboard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TiaBanner } from '@/components/custom/tia-banner';
import { WeekChallengePlayfulChallenges } from './WeekChallengePlayfulChallenges';
import { WeekChallengeRankingByRegion } from '../week-challenge-ranking-by-region';
import { WeekChallengeRankingByParticipant } from '../week-challenge-ranking-by-participant';
import tiaChallenge from '@/assets/images/tia/TIA-COMEMORANDO.png';

const PLAYFUL_TAB_CLASSNAME = 'data-[state=active]:bg-[var(--color-mission)] data-[state=active]:text-white data-[state=active]:font-extrabold data-[state=active]:shadow-[0_3px_0_var(--color-mission-dark)] data-[state=active]:-translate-y-px';

const BASE_ROUTE = '/desafio-da-semana';

function WeekChallengePlayful({ challenges, isLoading, selectedTab, uri, navigate }) {
  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: uri,
        name: 'Desafio da Semana',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <Tabs defaultValue={selectedTab || 'desafios'}>
        <TiaBanner
          className="mb-6 md:mt-16"
          image={tiaChallenge}
          text="Bora encarar o Desafio da Semana? Responda, ganhe pontos e suba no ranking! 🎮"
        />

        <TabsList className="mb-8 border border-neutral-lighter bg-white">
          <TabsTrigger
            value="desafios"
            className={PLAYFUL_TAB_CLASSNAME}
            onClick={() => navigate(`${BASE_ROUTE}/desafios`)}
          >
            Desafio
          </TabsTrigger>
          <TabsTrigger
            value="ranking-por-regiao"
            className={PLAYFUL_TAB_CLASSNAME}
            onClick={() => navigate(`${BASE_ROUTE}/ranking-por-regiao`)}
          >
            Ranking por região
          </TabsTrigger>
          <TabsTrigger
            value="ranking-por-participante"
            className={PLAYFUL_TAB_CLASSNAME}
            onClick={() => navigate(`${BASE_ROUTE}/ranking-por-participante`)}
          >
            Ranking por participante
          </TabsTrigger>
        </TabsList>

        <TabsContent value="desafios">
          <WeekChallengePlayfulChallenges
            challenges={challenges}
            isLoading={isLoading}
          />
        </TabsContent>
        <TabsContent value="ranking-por-regiao">
          <WeekChallengeRankingByRegion />
        </TabsContent>
        <TabsContent value="ranking-por-participante">
          <WeekChallengeRankingByParticipant />
        </TabsContent>
      </Tabs>
    </DashboardContent>
  );
}

export default WeekChallengePlayful;
